"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToDepartureDateMonth = void 0;
const react_1 = require("react");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const MONTH_CAPTION_HEIGHT = 24;
const FIRST_DATE_OF_DEPARTURE_DATES_MONTH_SELECTOR = '.DayPicker-Day--firstDayOfDepartureDate:not(.DayPicker-Day--outside)';
function useScrollToDepartureDateMonth() {
    const travelDatesWrapperEl = (0, react_1.useRef)(null);
    (0, libs_hooks_react_1.useIsomorphicLayoutEffect)(() => {
        const firstDayOfDepartureDateEl = document.querySelector(FIRST_DATE_OF_DEPARTURE_DATES_MONTH_SELECTOR);
        if (travelDatesWrapperEl &&
            travelDatesWrapperEl.current &&
            firstDayOfDepartureDateEl) {
            travelDatesWrapperEl.current.scrollTop =
                firstDayOfDepartureDateEl.offsetTop - MONTH_CAPTION_HEIGHT;
        }
    }, []);
    return travelDatesWrapperEl;
}
exports.useScrollToDepartureDateMonth = useScrollToDepartureDateMonth;
//# sourceMappingURL=useScrollToDepartureDateMonth.js.map